/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// attach event listeners
import Listeners from './vendor/listeners';

import Vue from 'vue'
import svg4everybody from 'svg4everybody';

/**
 * Events hub
 */
window.events = new Vue();

// import Vue components
import Flash from './components/Flash';
import WatchButton from './components/vendor/WatchButton';
import WarningPopup from './components/vendor/WarningPopup';
import SearchInput from './components/vendor/SearchInput';
import LoginForm from './components/forms/login/LoginForm';
import UserForm from './components/forms/users/UserForm';
import UsersList from './components/parts/users/UsersList';
import UsersStatsList from './components/parts/administration/UsersStatsList';
import UserDiscussionList from './components/parts/dashboard/UserDiscussionList';
import UserDocumentsList from './components/parts/dashboard/UserDocumentsList';
import DocumentsList from './components/parts/documents/DocumentsList';
import DocumentsAllList from './components/parts/documents/DocumentsAllList';
import DocumentsComments from './components/parts/documents/DocumentsComments';
import DocumentForm from './components/forms/documents/DocumentForm';
import DiscussionList from './components/parts/discussion/DiscussionList';
import DiscussionCreateForm from './components/forms/discussion/DiscussionCreateForm';
import DiscussionResponses from './components/parts/discussion/DiscussionResponses';
import HeaderDropdown from './components/parts/header/HeaderDropdown';
import Notifications from './components/parts/header/Notifications';
import Tabs from './components/vendor/Tabs';
import VueScrollTo from 'vue-scrollto';
import VueSweetalert2 from 'vue-sweetalert2';

const sweetAlertOptions = {
    confirmButtonColor: '#00334e',
    cancelButtonColor: '#d63031',
    confirmButtonText: 'Ano',
    cancelButtonText: 'Ne'
};

// sweet alert
window.swal = require('sweetalert2').mixin(sweetAlertOptions);

Vue.use(Tabs);
Vue.use(VueSweetalert2, sweetAlertOptions);

Vue.use(VueScrollTo, {
    container: "body",
    duration: 200,
    easing: "ease-in",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

/**
 * Vue root instance
 */
const rootVue = new Vue({

    el: '#app',

    components: {
        DocumentForm,
        Flash,
        LoginForm,
        UserForm,
        UsersList,
        UserDiscussionList,
        UserDocumentsList,
        HeaderDropdown,
        DocumentsList,
        DocumentsAllList,
        UsersStatsList,
        DocumentsComments,
        DiscussionCreateForm,
        DiscussionResponses,
        DiscussionList,
        WatchButton,
        WarningPopup,
        SearchInput,
        Notifications
    },

    mounted: function() {
        svg4everybody();

        Listeners.init();

        document.addEventListener('click', event => {
            this.$emit('closeAllDropdowns', event);
        });
    }
});

/**
 * Flash function
 *
 * @param  message      Alert message
 * @param  type         The type of alert
 * @param  important    Force user to close the flash window
 */
window.flash = (message, type = 'info', important = false) => {
    if (rootVue.$refs.flash) {
        rootVue.$refs.flash.flash(message, type, important)
    }
};
